import React, { useState } from 'react';
import './App.css';
import { Auth } from './Auth';
import NutritionMenu from './NutritionMenu';
import { Home } from './Home';
import Nav from './Nav';
import Profile from './Profile';
import Stats from './Stats';
import Workout from './Workout';
import { app } from './firebaseConfig.js';
import { Questions } from './Questions';

function App() {

    // Initialize Firebase
    /*const firebaseConfig = {
        apiKey: "AIzaSyC-pOrVQ22BmmD8TGQpgMHyr_PrHTo-jYw",
        authDomain: "fitbuddy-85b27.firebaseapp.com",
        projectId: "fitbuddy-85b27",
        storageBucket: "fitbuddy-85b27.appspot.com",
        messagingSenderId: "312024751054",
        appId: "1:312024751054:web:f53480cbc0b4d3266ae99f",
        measurementId: "G-3PSCXCBTJC"
    };
    const FireBaseApp = initializeApp(firebaseConfig);
    // Initialize Firebase Authentication and get a reference to the service
    const auth = getAuth(FireBaseApp);

    console.log(FireBaseApp); */
    
    const [authenticated, setAuthenticated] = useState(false);
    const [nav, setNav] = useState(0);
    const [page, setPage] = useState(0);

    //let authenticated = false;
    return(
        <>
            <div className="main-header">
                {page > 0 && page < 15 && (
                    <img src="right-arrow.svg" id="back-arrow" alt="הקודם" onClick={() => setPage(page - 1)}/>
                )}
                <img src="FitBuddyLogo.svg" id="logo"/>
            </div>
            <Questions page={page} setPage={setPage}/>
        </>
    );
    
  }

export default App;
